import ImageLayer from "ol/layer/Image.js";
import ImageWMS from "ol/source/ImageWMS.js";
import {
  QGIS_PROJECT_NAME,
  QGIS_PROJECT_URL,
} from "config/qgis";
import { createAuthenticatedQgisImageLoadFunction } from "../qgis/authenticatedImageLoadFunction";

export const MONITORED_NETWORK_LAYER_NAME = "monitored_network";
export const MONITORED_NETWORK_FORMAT = "image/png";
export const MONITORED_NETWORK_WMS_VERSION = "1.3.0";

export const createMonitoredNetworkLayer = ({
  projectUrl = QGIS_PROJECT_URL,
  onError,
} = {}) => {
  const source = new ImageWMS({
    url: projectUrl,
    params: {
      LAYERS: MONITORED_NETWORK_LAYER_NAME,
      FORMAT: MONITORED_NETWORK_FORMAT,
      TRANSPARENT: true,
      VERSION: MONITORED_NETWORK_WMS_VERSION,
    },
    serverType: "qgis",
    imageLoadFunction: createAuthenticatedQgisImageLoadFunction({ onError }),
  });

  const layer = new ImageLayer({
    source,
    visible: true,
  });

  layer.setProperties({
    id: MONITORED_NETWORK_LAYER_NAME,
    title: `${QGIS_PROJECT_NAME}: monitored network`,
  });

  return layer;
};
